import { FCOFields, FeatureViewFCO } from '../../../core/types/fcoTypes';

export const filterDataForOnlyFeatureViews = (data: { result: any[] }[], featureViews: FeatureViewFCO[]): any => {
  const featureViewIds = featureViews.map((featureView) => featureView[FCOFields.ID]);

  if (featureViews.length === 0) {
    return data;
  }

  const transformedData = data.map((queryResult) => {
    return {
      ...queryResult,
      result: queryResult.result.filter((resultRow) => {
        return featureViewIds.includes(resultRow.metric.feature_view_id);
      }),
    };
  });

  return transformedData;
};

export const filterDataForTableViewsOnly = (data: { result: any[] }[], featureViews: FeatureViewFCO[]): any => {
  const featureViewIds = featureViews.map((featureView) => featureView[FCOFields.ID]);

  return data.map((queryResult) => {
    return {
      ...queryResult,
      result: queryResult.result.filter((resultRow) => {
        let hasMatch = false;
        featureViewIds.forEach((fvId) => {
          if (resultRow.metric.table.endsWith(fvId)) {
            hasMatch = true;
          }
        });
        return hasMatch;
      }),
    };
  });
};
